// extracted by mini-css-extract-plugin
module.exports = {"highlightSection":"_341a98a","slider":"_ab9b572"};